import React from 'react';
import PropTypes from 'prop-types';
import { injectIntl } from 'react-intl';
import { useQuery, useApolloClient, gql } from '@apollo/client';
import { GET_LOCALE } from 'store/queries';
import { storeLocale } from 'utils/persistedLocale';

import StyledSelect from '../StyledReactSelect';

const handleChange = ({ value }, client) => {
  storeLocale(value);
  client.writeQuery({
    query: gql`
      query {
        locale @client
      }
    `,
    data: {
      locale: value
    }
  });
};

const LanguageSelector = ({ intl: { formatMessage } }) => {
  const client = useApolloClient();
  const { data } = useQuery(GET_LOCALE);

  const options = [
    {
      value: 'en-GB',
      label: `🇬🇧 ${formatMessage({ id: 'translations.english' })}`
    },
    {
      value: 'fr-FR',
      label: `🇫🇷 ${formatMessage({ id: 'translations.french' })}`
    },
    {
      value: 'nl-NL',
      label: `🇳🇱 ${formatMessage({ id: 'translations.dutch' })}`
    },
    {
      value: 'de-DE',
      label: `🇩🇪 ${formatMessage({ id: 'translations.german' })}`
    }
  ];

  return (
    <StyledSelect
      id="language-selector"
      className="react-select-container"
      classNamePrefix="react-select"
      mr="8px"
      isSearchable={false}
      options={options}
      onChange={(e) => handleChange(e, client)}
      value={options.find((o) => o.value === data?.locale)}
    />
  );
};

LanguageSelector.propTypes = {
  intl: PropTypes.shape({
    formatMessage: PropTypes.func
  })
};

export default injectIntl(LanguageSelector);
